<template>
  <div class="container">
    <h3 class="title">招生专业</h3>
    <div class="cards">
      <div class="card" @click="goNext('/zyxx?uName=专业设置&dname=' + item.zName)" v-for="(item, index) in majors"
        :key="index">
        <div class="card-header">{{ item.zName }}</div>
        <div style="padding: 14px">
          <div class="card-desc">
            <div class="fireElp">
              {{ item.zyContent }}
            </div>
          </div>
          <div class="card-tags">
            <span class="tag label">招生层次</span>
            <span class="tag">{{ item.zStage }}</span>
            <span v-if='item.studyName' class="tag label">学习形式</span>
            <span class="tag">{{ item.studyName }}</span>
          </div>
          <div class="linee"></div>
          <div class="card-buttons">
            <button @click.stop="goNext('/bm')" class="btn btn-outline">官方报名</button>
            <button @click.stop="showt()" class="btn btn-primary">在线咨询</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showQr" class="modal-mask" @click.self="showQr = false">
      <div class="modal-container">
        <img class="close-btn" @click.stop="showQr = false"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x53.png" alt="">
        <div class="modal-header">
          在线咨询
        </div>
        <div class="modal-body">
          <img class="qr-code" :src="qwCode" alt="二维码" />
          <p class="tip">扫码添加规划师 上岸快人一步</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryAllArticle, getJgZyListList } from "@/api/home";
import { TeacherClient } from '@/api/teacherClient.js'
let teacherClient = new TeacherClient()
export default {
  data() {
    return {
      showQr: false,
      majors: [
        {
          zName: '工商管理',
          zyContent: '工商管理专业是研究工商企业经济管理基本理论和一般方法的学科，主要包括企业的经营战略制定和内部行为管理两个方面。该专业旨在培养具备管理、经济、法律及企业管理方面的知识和能力，能在企、事业单位及政府部门从事管理以及教学、科研方面工作的工商管理学科高级专门人才。',
          zStage: '高起专',
          studyName: '全日制', 
        },
        {
          zName: '计算机科学与技术',
          zyContent: '计算机科学与技术是研究计算机的设计与制造，利用计算机进行信息获取、表示、存储、处理、控制等的理论、原则、方法和技术的学科。它涵盖了从计算机硬件到软件，从算法理论到实际应用的广泛领域，是一门综合性很强的学科。',
          zStage: '专升本',
          studyName: '全日制', 
        }
        ,
        {
          zName: '汉语言文学',
          zyContent: '汉语言文学专业隶属中国语言文学学科，专注于研究汉语和中国文学。通过对语言文字运用和文学文化内涵的探究，培养具备扎实语言文字功底、较强文学鉴赏能力与人文素养的专业人才，是传承和弘扬中华优秀传统文化的重要专业领域。',
          zStage: '高起专',
          studyName: '全日制', 
        }
        ,{
          zName: '法学',
          zyContent: '法学是一门研究法律现象及其规律的学科，涉及法律的制定、解释、实施、遵守以及法律与社会、经济、政治等方面的关系。它旨在培养学生掌握扎实的法律知识，具备运用法律思维分析和解决问题的能力，以及良好的法律职业道德和素养。',
          zStage: '专升本',
          studyName: '全日制', 
        }

      ],
      qwCode: ''
    };
  },
  created() {
    // getJgZyListList({ pageSize: 4, pageNum: 1, productLine: 3 }).then((res) => {
    //   this.majors = res.rows;
    // });
  },
  methods: {
    showt() {
      teacherClient.getEntrantsRelation({

      }).then((res) => {
        this.qwCode = res.data.qwCode
      })
      this.showQr = true;
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  .title {

    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    margin-bottom: 20px;
  }

  .cards {
    display: flex;
    justify-content: space-between;

    .card {
      width: 282px;
      height: 306px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      cursor: pointer;

      .card-header {
        width: 282px;
        height: 52px;
        background: #e1f6ff;
        border-radius: 12px 12px 0px 0px;
        font-family: DingTalk JinBuTi, DingTalk JinBuTi;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        line-height: 52px;
        text-align: center;
      }

      .card-desc {
        width: 254px;
        height: 112px;
        background: #f6fbff;
        border-radius: 12px 12px 12px 12px;
        padding: 14px;
        font-family: DingTalk JinBuTi, DingTalk JinBuTi;
        font-weight: 400;
        font-size: 15px;
        color: #656c75;
        line-height: 22px;
      }

      .card-tags {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 14px 0;

        .tag {
          border-radius: 4px 4px 4px 4px;
          margin-right: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #333333;

          &.label {
            background: #fff1e9;
            width: 64px;
            height: 27px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 13px;
            color: #ff580d;
          }
        }
      }

      .linee {
        margin-bottom: 14px;
        border-bottom: 1px dashed #eee;
        /* 1px 黑色虚线 */
        border-image: repeating-linear-gradient(90deg,
            #eee,
            #eee 5px,
            transparent 5px,
            transparent 10px);
        border-image-slice: 1;
      }

      .card-buttons {
        display: flex;
        justify-content: space-between;

        .btn {
          width: 121px;
          height: 39px;
          cursor: pointer;
          outline: none;
          border: 1px solid transparent;
          border-radius: 8px 8px 8px 8px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #2080f7;
          display: flex;
          justify-content: center;
          align-items: center;

          &.btn-outline {
            background: #fff;

            border-color: #3a7efc;
          }

          &.btn-primary {
            background: linear-gradient(180deg, #3a7efc 0%, #1a5dfc 100%);
            color: #fff;
            border: none;
          }
        }
      }
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  position: relative;
  width: 357px;
  height: 374px;
  background: #F6FAFF;
  background-image: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x52.png');
  background-size: 100% 100%;
  border-radius: 12px;
}

.close-btn {
  position: absolute;
  display: block;
  right: 24px;
  top: 20px;
  width: 16px;
  cursor: pointer;
  z-index: 99;

}

.modal-header {
  position: relative;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  text-align: center;
  margin-top: 20px;


}

.modal-body {
  margin-top: 20px;

  .qr-code {
    width: 254px;
    height: 254px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    object-fit: contain;
    margin: 0 auto;
  }

  .tip {

    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #A3A9BA;
    margin-top: 14px;
    text-align: center;
  }
}
</style>
